import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import ReportsSections from '../../ReportsSections';

import { DialogReportsCommonProps } from '../types';
import {
  DialogReportsContainer,
  DialogReportsHeader,
  DialogReportsHeaderCloseIcon,
  DialogReportsContent,
} from '../styles';

const DialogReportsHeatmap = ({
  open,
  onClose,
}: DialogReportsCommonProps): ReactElement => (
  <DialogReportsContainer
    open={open}
    PaperProps={{ sx: { maxWidth: 1200, height: '100%' } }}
  >
    <DialogReportsHeader>
      <Typography component="h2" variant="h6">
        Mapa de calor
      </Typography>

      <DialogReportsHeaderCloseIcon
        aria-label="close"
        onClick={onClose}
        size="small"
      >
        <CloseIcon />
      </DialogReportsHeaderCloseIcon>
    </DialogReportsHeader>

    <DialogReportsContent dividers>
      <ReportsSections.Heatmap />
    </DialogReportsContent>
  </DialogReportsContainer>
);

export default DialogReportsHeatmap;
